import * as React from 'react';
import { Facet } from '@elastic/react-search-ui';
import { useClickOutside } from '../../helper';
import classnames from "classnames";

export default function OpenSearchFacet(props) {
  const {field, label, show, hidden = false} = props;

  const [isOpen, setIsOpen] = React.useState(false);

  const rootEl = React.useRef(null);

  const handleClickOutside = () => {
    if (isOpen) {
      setIsOpen(false);
    }
  };

  useClickOutside(rootEl, handleClickOutside);

  const handleClick = () => {
    setIsOpen(prev => !prev);
  }

  const css = {
    root: classnames({
      'facet': true,
      'facet--dropdown': true,
      'facet--expanded': isOpen,
      'facet--hidden': hidden,
    }),
  }

  return (
    <div className={css.root} ref={rootEl}>
      <button className='facet__button' onClick={handleClick}>
        {label}
      </button>
      <div className='facet__items'>
        <div className='facet__scroll'>
          <Facet field={field} show={show} label={label} filterType='any'/>
        </div>
      </div>
    </div>
  )
}
